module.exports = __webpack_public_path__ + "static/img/bg_reward_item_purple.f1811944.svg";